import { useQuery } from '@tanstack/react-query';
import OrganizationService from '@services/Organization/organization.service';

export const useDepartments = (brandId: number | null) => {
  return useQuery({
    queryKey: ['departments', brandId],
    queryFn: ({ signal }) => OrganizationService.getBrandDepartments(brandId!, signal),
    enabled: !!brandId, 
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000, 
  });
};